import jwtDecode from "jwt-decode";
import pako from "pako";
import base64 from "base-64";
var PerkboxToken = /** @class */ (function () {
    /**
    * PerkboxToken Constructor
    * @param  {string} myToken JWT Token
    */
    function PerkboxToken(myToken) {
        var decoded = jwtDecode(myToken);
        if (decoded == null) {
            throw new Error("Invalid token");
        }
        this.claims = decoded;
        var _buffer = base64.decode(this.claims.aut);
        var restored = JSON.parse(pako.inflate(_buffer, { to: "string" }));
        this.permissions = restored;
        this.myToken = myToken;
    }
    /**
    * Returns the actual access token
    * @return {string} Access token
    */
    PerkboxToken.prototype.getToken = function () {
        return this.myToken;
    };
    /**
    * Get a claim from the parsed token (throws error on fail)
    * @param  {string} val Claim name
    * @return {string}     Claim value
    */
    PerkboxToken.prototype.need = function (val) {
        var res = this.get(val);
        if (!res)
            throw new Error("Claim " + val + " not found");
        return res;
    };
    /**
    * Get a claim from the parsed token
    * @param  {string}         val     Claim name
    * @return {string|null}            Claim value or null
    */
    PerkboxToken.prototype.get = function (val) {
        return this.claims[val] || null;
    };
    /**
    * Get all claims
    * @return {object}
    */
    PerkboxToken.prototype.getClaims = function () {
        return this.claims;
    };
    /**
    * Check if a specific permission exists in the token
    * @param  {string}  service  Service name
    * @param  {string}  resource Resource name
    * @param  {string}  action   Action name (CRUD)
    * @return {Boolean}
    */
    PerkboxToken.prototype.isAllowed = function (_a) {
        var service = _a.service, resource = _a.resource, action = _a.action, restriction = _a.restriction;
        return !!this.getRestrictions({ service: service, resource: resource, action: action, restriction: restriction });
    };
    /**
    * Check if a specific restriction is allowed
    * @param  {string}  service  Service name
    * @param  {string}  resource Resource name
    * @param  {string}  action   Action name (CRUD)
    * @return {Array}
    */
    PerkboxToken.prototype.getRestrictions = function (_a) {
        var service = _a.service, resource = _a.resource, action = _a.action, restriction = _a.restriction;
        var permissions = this.permissions;
        var _service = permissions[service];
        if (!_service)
            return false;
        var _resource = _service[resource];
        if (!_resource)
            return false;
        var allowedAction = _resource["+" + action];
        if (!allowedAction)
            return false;
        if (!restriction) {
            return _resource["+" + action];
        }
        return _resource["+" + action]["*" + restriction];
    };
    /**
    * Get an object of requirements for a specific action
    * @param  {string}  service  Service name
    * @param  {string}  resource Resource name
    * @param  {string}  action   Action name (CRUD)
    * @return {Boolean}
    */
    PerkboxToken.prototype.getRequirements = function (service, resource, action) {
        var allowedAction = this.permissions[service][resource]["+" + action];
        if (!allowedAction)
            return false;
        return allowedAction;
    };
    return PerkboxToken;
}());
export default PerkboxToken;
